import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button, Alert, Container, Label, Form } from "reactstrap";
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import { loginUser } from '../../store/actions';

// Import images
import logodark from "../../assets/images/brandstrek-logo.png";
import logolight from "../../assets/images/logo-light.webp";

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loginError = useSelector((state) => state.Login?.error || null);

    const { register, handleSubmit, formState: { errors } } = useForm();
    // console.log("Current values:", watch());

    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        document.body.classList.add("auth-body-bg");
        return () => document.body.classList.remove("auth-body-bg");
    }, []);

    const togglePasswordVisibility = () => {
        setShowPassword(prevState => !prevState);
    };

    const onSubmit = (data) => {
        console.log("Form Data Submitted:", data);
        dispatch(loginUser(data, navigate));
    };

    return (
        <Container fluid className="p-0">
            <Row className="g-0">
                <Col lg={6}>
                    <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                        <div className="w-100">
                            <Row className="justify-content-center">
                                <Col lg={9}>
                                    <div>
                                        <div className="text-center">
                                            <Link to="/">
                                                <img src={logodark} alt="logo" height="50" className="auth-logo logo-dark mx-auto" />
                                                <img src={logolight} alt="logo" height="50" className="auth-logo logo-light mx-auto" />
                                            </Link>
                                            <h4 className="mt-4">Welcome Back!</h4>
                                            <p className="text-muted">Sign in to continue to Brandstrek.</p>
                                        </div>

                                        {loginError && <Alert color="danger">{loginError}</Alert>}

                                        <div className="p-2 mt-5">
                                            <Form onSubmit={handleSubmit(onSubmit)} >
                                                <div className="auth-form-group-custom mb-4">
                                                    <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                    <Label htmlFor="email">Email</Label>
                                                    <input
                                                        {...register("email", { required: "Email is required" })}

                                                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                        id="email"
                                                        placeholder="Enter email"
                                                        type='email'
                                                    />
                                                    {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                                                </div>

                                                <div className="auth-form-group-custom mb-4 position-relative">
                                                    <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                    <Label htmlFor="password">Password</Label>
                                                    <input
                                                        {...register("password", { required: "Password is required" })}
                                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                                        id="password"
                                                        placeholder="Enter password"
                                                        type={showPassword ? "text" : "password"}
                                                    />
                                                    <i
                                                        className={`ri-eye${showPassword ? "" : "-off"}-line password-toggle-icon`}
                                                        onClick={togglePasswordVisibility}
                                                        style={{
                                                            position: "absolute",
                                                            right: "10px",
                                                            top: "20px",
                                                            cursor: "pointer",
                                                        }}
                                                    ></i>
                                                    {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
                                                </div>

                                                <div className="form-check">
                                                    <Input type="checkbox" className="form-check-input" id="customControlInline" />
                                                    <Label className="form-check-label" htmlFor="customControlInline">Remember me</Label>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <Button color="primary" className="w-100" type="submit">Log In</Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <Link to="/forgot-password" className="text-muted"><i className="mdi mdi-lock me-1"></i> Forgot your password?</Link>
                                                </div>
                                            </Form>
                                        </div>

                                        <div className="mt-5 text-center">
                                            <p>© 2025 Brandstrek. Crafted with <i className="mdi mdi-heart text-danger"></i> by <a href='https://brandstrek.com'>Brandstrek</a></p>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className="authentication-bg">
                        <div className="bg-overlay"></div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
